// extracted by mini-css-extract-plugin
export default {"searchinput":"Searchinput_searchinput__pLEzo","icon":"Searchinput_icon__dMsNj","input":"Searchinput_input__+d1yA"};